module.exports = __webpack_public_path__ + "img/grey_037.b49ebb63.png";